/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SubmitLifeApplicationMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitLifeApplicationMutationInput;
}>;


export type SubmitLifeApplicationMutation = { __typename?: 'Mutation', life_applications: { __typename?: 'LifeApplications', submit_life_application: { __typename?: 'SubmitLifeApplicationMutationPayload', life_application: { __typename?: 'LifeApplication', id: string, status: string } | null } | null } };


export function useSubmitLifeApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLifeApplicationMutation, SubmitLifeApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLifeApplicationMutation, SubmitLifeApplicationMutationVariables>(Operations.SubmitLifeApplication, options);
      }
export type SubmitLifeApplicationMutationHookResult = ReturnType<typeof useSubmitLifeApplicationMutation>;